// extracted by mini-css-extract-plugin
export var centerText = "_cx-8";
export var container = "_cx-0";
export var doughnutContainer = "_cx-7";
export var legend = "_cx-a";
export var legendItemColorDisplay = "_cx-b";
export var legendItemLabel = "_cx-d";
export var legendItemValue = "_cx-c";
export var lg = "_cx-5";
export var maxWidth = "_cx-9";
export var md = "_cx-4";
export var responsive = "_cx-6";
export var sm = "_cx-3";
export var xs = "_cx-2";
export var xxs = "_cx-1";